module.exports = "/_next/static/images/ab5b7cd60da232527e7a736d65100c26-usa.svg.webp";